import { render } from "./alltotalList2.vue?vue&type=template&id=13398c60&scoped=true"
import script from "./alltotalList2.vue?vue&type=script&lang=js"
export * from "./alltotalList2.vue?vue&type=script&lang=js"

import "./alltotalList2.vue?vue&type=style&index=0&id=13398c60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13398c60"]])

export default __exports__